<div class="pills-container">
	<tabset type="pills" #tabs>
		<tab heading="{{ 'annotations.tabs.PRIVATE' | translate }}" id="private-annotation--pill-link" tab (selectTab)="switchAnnotations('private', $event)"></tab>
		<tab id="public-annotation--pill-link" *ngIf="displayAnnotations" (selectTab)="switchAnnotations('public', $event)" tab [disabled]="!allowAnnotations">
			<ng-template tabHeading>
				<span [title]="(allowAnnotations ? '' : 'annotations.tabs.PUBLIC.tooltip') | translate">{{ 'annotations.tabs.PUBLIC' | translate }}</span>
			</ng-template>
		</tab>
	</tabset>
</div>
